import { BaseWebComponentElement } from '../../../../../../framework/BaseWebComponentElement';
import { ChildGroupsGridController } from '../controller/ChildGroupsGridController';

export class ChildGroupsGridWebComponent extends BaseWebComponentElement {
  constructor() {
    super();
    this.initialSetup({
      controllerConstructor: ChildGroupsGridController,
    });
  }
}
